import * as React from "react"
import { MobXProviderContext, observer } from "mobx-react";
import { Button, FormControlLabel, Link, makeStyles, MenuItem, Radio, RadioGroup, Snackbar, SnackbarContent, ThemeProvider, Typography } from "@material-ui/core";
import { MUIDialog, MUISelect, Theme } from "../../entryes/panel/MUI";
import CloseIcon from "../Icons/close";
import api from "../../api";
import { ITranscriptionPrices } from "../../api/transcriptions";
import { plural, tl } from "../../utils";
import classNames from "classnames";
import * as moment from "moment";
import FSStore from "../../entryes/panel/Filestorage/store";

interface TranscriptionBuyPopupProps {
  open: boolean;
  onClose: (success: boolean) => void;
  preview: string;
  fileId: string;
  courseId: string;
  model?: string;
}

interface IFormValues {
  language: string,
  model: string,
}

//TODO: полоса прогресса
export const TranscriptionBuyPopup: React.FC<TranscriptionBuyPopupProps> = observer(({
  open, onClose, preview, fileId, courseId, model
}) => {
  const { fsStore } = React.useContext<{fsStore: FSStore}>(MobXProviderContext);
  const [modalData, setModalData] = React.useState<ITranscriptionPrices>(undefined);
  const [formValues, setFormValues] = React.useState<IFormValues>(undefined);
  const [balance, setBalance] = React.useState<number>(null);
  const [transcribeSnackbar, setTranscribeSnackbar] = React.useState<string | boolean>(false);

  const payCard = () => {
    api.transcriptions.createTranscription(courseId, {file: Number(fileId), model: formValues.model, language: formValues.language}).then((transcription) => {
      onClose(true);
      setTranscribeSnackbar('success');
      if (fsStore) fsStore.onTranscribeCreate(transcription, 'success');
    }
    ).catch(() => {
      onClose(false);
      setTranscribeSnackbar('fail');
      if (fsStore) fsStore.onTranscribeCreate({}, 'fail');
    }
    );
  };
  
  React.useEffect(() => {
    if (open) {
      api.transcriptions.getPrices(courseId, fileId).then((res) => {
        setModalData(res);
        setFormValues({language: res.languages[0].language, model: model ?? res.prices[0].model});
      });
      api.transcriptions.getBalance(courseId).then((res) => {
        setBalance(res.ai);
      })
    }
  }, [open])

  const classes = useStyles();
  return (
    <>
      <MUIDialog pInner={0} notFullWidth noclose notitle mobileFullWidth open={open} onClose={() => onClose(false)} PaperProps={{className: classes.paper}}>
        {formValues &&
          <div className={classes.inner}>
            <div className={classes.imageContainer}>
              <img src={preview} width="100%" height="auto" style={{borderRadius: 4}} />
              <strong>{modalData.file.name}</strong>
            </div>

            <div className={classes.form}>
              <span className={classes.header}>{tl('Видео готово к транскрибации')}</span>

              <div className={classes.formRow}>
                <span>{tl('Язык')}</span>
                <MUISelect
                  className={classNames(classes.select, classes.formValue)}
                  variant="outlined"
                  fullWidth
                  value={formValues.language}
                  onChange={(evt: any) => setFormValues({...formValues, language: evt.target.value})}
                >
                  {modalData.languages.map((language: any) => (
                    <MenuItem
                      value={language.language}
                      key={`${language.language}`}
                      style={{padding: '8px 16px', width: '100%', justifyContent: 'start'}}
                    >
                      {language.name}
                    </MenuItem>
                  ))}
                </MUISelect>
              </div>

              {/*<div className={classes.formRow}>
                <span>{tl('Длина видео')}</span>
                <span className={classes.formValue}>{moment().startOf('day').seconds(modalData.duration).format('HH:mm:ss')}</span>
              </div>*/}

              <div>
                <Typography>
                  {plural('За транскрибацию будет списан %d запрос', modalData.prices[0]?.price)}
                </Typography>

                <Typography>
                  {plural('На вашем балансе доступно %d запрос', balance)}
                </Typography>
              </div>

              {balance < modalData.prices[0]?.price && (window.isCurator ? (
                <span style={{textAlign: 'center', color: '#5667F6'}}>{tl("Обратитесь к автору, чтобы он докупил запросы")}</span>
              ) : (
                <Link href="/panel/plan">
                  <Button style={{width: '100%'}} className={classes.button} variant="text" color="primary">
                    {tl('Докупить запросы для транскрибации')}
                  </Button>
                </Link>))
              }

              <span className={classes.textBg}>{tl('Мы создали специальный урок, в котором вы можете посмотреть пример готовой транскрибации.')} <a href='/student/lessons/lesson?course_id=28315&lesson_id=7912510'>Посмотрите прямо сейчас</a></span>

              {/*<div className={classes.formRow} style={{alignItems: 'start'}}>
                <span>{tl('Модель транскрибации')}</span>
                <RadioGroup className={classNames(classes.radio, classes.formValue)} name="legalEntityType" value={formValues.model} onChange={(evt: any) => setFormValues({...formValues, model: evt.target.value})}>
                  {modalData.prices.map(item => (
                    <FormControlLabel label={`${item.name} (${item.price})`} key={item.model} labelPlacement="end" style={{margin: 0}} control={<Radio color="primary" value={item.model} key={item.model} style={{padding: 0, marginRight: 8}} />} />
                  ))}
                </RadioGroup>
              </div>

              <span>{tl('Для начала транскрибации вашего видеофайла  необходимо произвести оплату')}</span>
              <span>{tl('*Продвинутая версия нейросети лучше распознает текст видео и предоставляет больше возможностей в настройке стилей')}</span>*/}
            </div>

            <div className={classes.buttonsContainer}>
              <Button className={classNames(classes.button, classes.buttonContained)} variant="contained" color="primary" onClick={payCard} disabled={balance < modalData.prices[0]?.price}>
                {tl('Начать транскрибацию')}
              </Button>
            </div>
          </div>
        }
        <CloseIcon className={classes.closeIcon} onClick={() => onClose(false)}></CloseIcon>
      </MUIDialog>

      <Snackbar open={!!transcribeSnackbar} anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
        <SnackbarContent
          className={classes.snackbarContent}
          message={
            <div className={classes.snackbarMessage}>
              <span style={{fontSize: 16, fontWeight: 700}}>{transcribeSnackbar === 'success' ? tl('Транскрибация создана') : tl('Транскрибация не создана')}</span>
              <span>{transcribeSnackbar === 'success' ? tl('Дождитесь обработки и вы сможете найти ее в разделе транскрибации') : tl('Попробуйте запустить транскрибацию заново через пару минут. Токены при этом не будут списаны повторно')}</span>
              <CloseIcon className={classes.closeIcon} onClick={() => setTranscribeSnackbar(false)} />
            </div>
          }
        />
      </Snackbar>
    </>
  )
});


const useStyles = makeStyles((theme) => ({
  paper: {
    boxSizing: 'border-box',
    margin: 0,
    padding: '40px 40px',
    width: 404,
    maxWidth: 'calc(100% - 32px)',

    '@media screen and (max-width: 767px)': {
      padding: '40px 12px',
    },
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    top: 12,
    right: 12,
    color: '#5667F6',
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  header: {
    fontSize: 16,
    fontWeight: 700,
    color: '#3F53D9',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 11,
    padding: 12,
    border: '1px solid #E3E4E8',
    borderRadius: 8,
    boxShadow: '0px 10px 20px 0px rgba(0, 0, 0, 0.05);',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    fontSize: 13,
  },
  formRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflowX: 'hidden',
  },
  formValue: {
    width: 149,
  },
  select: {
    height: 34,
    fontSize: 13,

    '& .MuiSelect-select': {
      boxSizing: 'border-box',
      lineHeight: 'normal',
    }
  },
  radio: {
    gap: 4,
  },
  textBg: {
    backgroundColor: '#F0F7FD',
    padding: 8,
    borderRadius: 4,
    fontSize: 13,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  button: {
    fontSize: 13,
    textTransform: 'none',
    color: '#5667F6',
  },
  buttonContained: {
    backgroundColor: '#5667F6',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#374BF1',
    },

    '&.Mui-disabled': {
      backgroundColor: '#5667F666',
      color: theme.palette.common.white,
    }
  },
  snackbarContent: {
    background: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  snackbarMessage: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 13,
    gap: 8,
    maxWidth: 360,
  },
}))